/*Package importing*/

/*Import custom components and assets*/

const Loader = (props) => {
 return (
    <img src={require("../../Assets/Images/loader.gif")}
      width={props.width}
      height={props.height}
      className="object-fit-contain" />
  );
}

export default Loader;
